import { Component, OnInit, TemplateRef, ElementRef, ViewChild } from '@angular/core';
import { Router,ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../services/login.service'
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2'
import { AppValidationService } from '../app-validation/app-validation.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  public Base_Url = environment['adminServerUrl'];
  modalRef: BsModalRef;
  addUserFrom: FormGroup;
  loginButtonDisable = false
  submitted = false;
  showResponseMessage;
  public showPassword: boolean;
  private clickTimeout = null;
  a: any;
  otpVerify:any=false;
  timers:any;
  logo: string;
  loading: boolean;
  domainName: string;
  domainData: any;
  isAddUserFromSubmitted: boolean;
  referCode: string;
  refer_Code: string;
  domain:any
  loginSubmitted:any
  constructor(private route: ActivatedRoute,private router: Router, private modalService: BsModalService,
    private fb: FormBuilder,
    private loginService: LoginService, private cookie: CookieService,
    private toastr: ToastrService, private spinner: NgxSpinnerService,private appValidationService: AppValidationService) {

      this.domain = window.location.hostname;
      if(this.route.snapshot.paramMap.get('referCode')){
        this.refer_Code=this.route.snapshot.paramMap.get('referCode')
      }
     }

    ngOnInit(): void {
      // this.logo = window.location.hostname;
      let a = localStorage.getItem('userAccessToken');
      this.referCode = localStorage.getItem('referCode') != undefined ? localStorage.getItem('referCode')  : '';
      
      if (a != undefined) {
        this.router.navigate(['dashboard'])
      }
      this.domainName = window.location.origin;
     
      this.getLoginLogo();
      this.createFrom();
      // this.clearCookieAndLocalStorage();
    }
  
    getLoginLogo() {
      let data = {
        key: btoa(this.domainData)
        // key: 'cHVycGxlMjUuY29t'
      }
      this.logo="assets/logo/"+this.domain+".png";
    localStorage.setItem('logo', this.logo)
   
    }
   
    createFrom() {
      this.addUserFrom = this.fb.group({
        user_name: ['', [Validators.required]],
        name: ['', [Validators.required]],
        password: ['', [Validators.required]],
        verify_domain: [this.domain, [Validators.required]],
        otp: [''],
        refer_code:['',[]],
        orderId: [''],
        mobile: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
       
      })

     
     
      this.applyValidationToFormGroup(this.addUserFrom, "AddUser")
    }

    applyValidationToFormGroup(formGroupName, jsonArrayName) {
      this.appValidationService.applyValidationRulesToFromGroup(formGroupName, jsonArrayName).then((validators) => {
      }).catch(() => { })
    }

    isControlIsValid(controlName: string): boolean {
      if (this.addUserFrom.controls[controlName].invalid && (this.isAddUserFromSubmitted || this.addUserFrom.controls[controlName].dirty || this.addUserFrom.controls[controlName].touched)) {
        return true;
      }
      return false;
    }
    isControlHasErros(controlName: string) {
      if (this.addUserFrom.controls[controlName].errors) {
        let value = ''
        let object =this.addUserFrom.controls[controlName].errors
        for (var propName in object) {
            if (object.hasOwnProperty(propName) && propName != "required") {
                value = object[propName];
            }
        }
        return value;
      }
      return null;
    }
  
  
    private markFormGroupTouched(formGroup: FormGroup) {
      (<any>Object).values(formGroup.controls).forEach(control => {
        control.markAsTouched();
  
        if (control.controls) {
          this.markFormGroupTouched(control);
        }
      });
    }
  
    get f() { return this.addUserFrom.controls; }
  
    async onSubmitLogin() {
      this.loginButtonDisable = true
      this.addUserFrom.controls['name'].setValue(this.addUserFrom.value.user_name);
      this.appValidationService.markFormGroupTouched(this.addUserFrom);
     
      this.loading = true;
      this.spinner.show();
      this.submitted = true;
      if (this.clickTimeout) {
        this.setClickTimeout(() => { });
      } else {
        // if timeout doesn't exist, we know it's first click 
        // treat as single click until further notice
        this.setClickTimeout(() =>
          this.handleSingleLoginClick());
      }
    }
    public handleSingleLoginClick() {
      //The actual action that should be performed on click      
      this.submitted = true;
      this.a = (this.addUserFrom.value.user_name);
      let b = (this.a).toLowerCase()
      this.addUserFrom.value.user_name = b;
      if(this.otpVerify){
        this.afterSubmitOtp()
      }
      else{
        this.registerUser()
     
      }
     
    }

    afterSubmitOtp(){
      if(this.addUserFrom.controls['otp'].value==""){
        this.toastr.success('Otp is required.!', '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        })
        return

      }
    
      this.loginService.register(this.addUserFrom.value).subscribe((result) => {
        if (result.status == true) {

          const data={user_name:this.addUserFrom.controls['user_name'].value,
                      password:this.addUserFrom.controls['password'].value,
                      grant_type:'password'
                    }

          this.loginService.submitlogin(data).subscribe((result) => {
            if (result.status == true) {
              this.setCokkies(result);
              this.toastr.success(result.msg, '', {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
              //  this.setCokkies(result);
              localStorage.setItem('userDetails', JSON.stringify(result.data));
              localStorage.setItem('operator', JSON.stringify(result.operatorId));
              this.spinner.hide();
              this.loading = false;
              this.redirectToDashboard();
            } else {
              this.showResponseMessage = result.msg;
              this.spinner.hide();
              this.loading = false;
              this.loginButtonDisable = false
            }
          }, (err) => {
            console.log(err);
          });
      
        } else {
          this.showResponseMessage = result.msg;
          this.spinner.hide();
          this.loading = false;
          this.loginButtonDisable = false
        }
      }, (err) => {
        console.log(err);
        this.spinner.hide();
        this.loading = false;
      });
    }
  
    async redirectToDashboard() {
      // var acctoken = await this.cookie.get('accessToken');
      var acctoken = localStorage.getItem('userAccessToken');
      if (acctoken != null && acctoken != undefined && acctoken != '') {
        this.router.navigate(['dashboard'])
        localStorage.setItem('showAutoPopup', 'true');
      }
    }

    registerUser() {
      this.submitted = true;
      this.loginSubmitted = false;
      this.addUserFrom.controls['name'].setValue(this.addUserFrom.controls['user_name'].value.toLowerCase())
      this.addUserFrom.controls['user_name'].setValue(this.addUserFrom.controls['user_name'].value.toLowerCase())
      this.addUserFrom.controls['verify_domain'].setValue(this.domain);
      if(this.refer_Code){
    if (this.addUserFrom?.controls['refer_code']) {
      this.addUserFrom.controls['refer_code'].setValue(this.refer_Code);
      }
    }
    else{
     this.addUserFrom.removeControl('refer_code');
    }
  
      this.spinner.hide();
      
       this.loginButtonDisable=false
      
      let params={
              mobile:this.addUserFrom.controls['mobile'].value,
              domain:this.addUserFrom.controls['verify_domain'].value,
      }
      if (this.addUserFrom.valid) {
        this.loginService.registerwithOtp(params).subscribe({
          next: (res: any) => {
            if (res.status) {
               
               this.otpVerify=true
               this.addUserFrom.controls['orderId'].setValue(res.orderId)
               this.toastr.success(res.msg, '', {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
              this.countTimer()
            }
            else{
             
              this.toastr.error(res.msg, '', {
                positionClass: 'toast-top-center',
                timeOut: 2000
              })
            }
          },
          error: () => {},
        });
  
      }
    }
  
    async setCokkies(result) {
      // this.cookie.set('accessToken', result.token.accessToken);
      localStorage.setItem('userAccessToken', result.token.accessToken);
      this.cookie.set('userId', result.data._id);
  
      // this.cookie.set('refreshToken', result.token.refreshToken);
      localStorage.setItem('userRefreshToken', result.token.refreshToken);
      var acctoken = localStorage.getItem('userAccessToken');
  
      this.router.navigate(['dashboard'])
      localStorage.setItem('showAutoPopup', 'true');
  
    }

    resetOtp(){
      let params={
       "orderId":this.addUserFrom.controls['orderId'].value
      }
     this.loginService.resetOtp(params).subscribe({
       next: (res: any) => {
         if (res.status) {
           this.countTimer()
         }
         else{
           
         }
       },
       error: () => {},
     });
   }

   countTimer() {
    this.timers = 120;
    const self = this; // Store reference to `this`

    const countdown = setInterval(function() {
        // Calculate minutes and seconds
        const minutes = Math.floor(self.timers / 60);
        const seconds = self.timers % 60;

        // Display the timer in MM:SS format
        

        // Decrease the time left by 1 second
        self.timers--;

        // Check if the time has run out
        if (self.timers < 0) {
            clearInterval(countdown);
        }
    }, 1000);
}
  
    // sets the click timeout and takes a callback 
    // for what operations you want to complete when
    // the click timeout completes
    public setClickTimeout(callback) {
      // clear any existing timeout
      clearTimeout(this.clickTimeout);
      this.clickTimeout = setTimeout(() => {
        this.clickTimeout = null;
        callback();
      }, 400);
    }
  
    clearCookieAndLocalStorage() {
      this.cookie.delete('userId');
      // this.cookie.delete('accessToken');
      // this.cookie.delete('refreshToken');
      this.cookie.delete('is_socket');
  
      this.loginService.clearLocalStorage()
  
    }
   

}
